import { createApiActionTypes, fetchReducer } from 'iqvia-shared';
import reduceReducers from 'reduce-reducers';

import apiNameEnums from '../../../Enums/apiNames';

export const defaultState = {
  isLoading: false,
  error: null,
  isError: false,
  isHCOEnabled: false,
};
export const getIsHCOEnabledTypes = createApiActionTypes(apiNameEnums.GET_ISHCOENABLED);

const featureFlag = (state = defaultState, { type, payload }) => {
  switch (type) {
    case getIsHCOEnabledTypes.request.type: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case getIsHCOEnabledTypes.success.type: {
      return {
        ...state,
        isLoading: false,
        isHCOEnabled: payload,
        isError: false,
        error: null,
      };
    }

    case getIsHCOEnabledTypes.failure.type: {
      return {
        ...state,
        isLoading: false,
        isHCOEnabled: false,
        isError: true,
        error: payload,
      };
    }

    default:
      return state;
  }
};

export default reduceReducers(featureFlag, fetchReducer(apiNameEnums.GET_ISHCOENABLED));



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/reducers/featureFlag.js